import { useState } from "react";
import { API_URL } from "../../config";
import Button from "../ui/Button";

import classes from "./LoginPage.module.css";

function LoginPage({ setUser }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [isWorking, setIsWorking] = useState(false);
  const [error, setError] = useState(null);

  const loginHandler = (e) => {
    e.preventDefault();
    setIsWorking(true);
    setError(null);
    fetch(API_URL + "api/authenticate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username,
        password,
      }),
    })
      .then((response) => {
        if (!response.ok)
          setError({
            message: `(${response.status}) ${response.statusText} ${
              response.ok ? "OK" : "NOT OK"
            }`,
          });
        else return response.json();
      })
      .then((data) => {
        if (data) {
          setUser({
            id: data.user.id,
            username: data.user.username,
            token: data.token,
            expireAt: data.expire,
            permissions: data.user.permissions,
          });
        }
      })
      .catch((err) => {
        setError({ message: "Error. See console" });
        console.log(err);
      })
      .finally(() => setIsWorking(false));
  };

  return (
    <form className={classes.loginForm} onSubmit={loginHandler}>
      <div className={classes.wrapper}>
        <input
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          disabled={isWorking}
          type='text'
          placeholder='Login'
        />
        <input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={isWorking}
          type='password'
          placeholder='Password'
        />
        {error && error.message && <div>{error.message}</div>}
        <Button type='submit' disabled={isWorking}>
          Login!
        </Button>
      </div>
    </form>
  );
}

export default LoginPage;
